export default { sha: '69d3bcf042443283145e7abd2521b6fadc2ec1aa', buildNumber: 'undefined' }
